export const PORTAL_COTACOES = () => '/portal-cotacoes';
export const PORTAL_COTACOES_APROVACOES = () => '/portal-cotacoes/aprovacoes';
/** Acompanhamento do fluxo (item 9 do backlog, 13/08/2026) — leitura, não fila de trabalho. */
export const PORTAL_COTACOES_SUPERVISAO = () => '/portal-cotacoes/supervisao';
export const PORTAL_COTACAO_DETALHE = (id = ':id') => `/portal-cotacoes/${id}`;
/** Rota pública do fornecedor — sem guard, com code-splitting. */
export const COTACAO_PUBLICA = (token = ':token') => `/cotacao/${token}`;

/*
 * A configuração do módulo NÃO mora aqui (at-73): saiu de `/portal-cotacoes/config`
 * para `/admin/sistema/cotacoes`, dentro da Administração do Sistema, que passou a
 * ser organizada por módulo. A rota vive em `views/admin-sistema/routes.ts`
 * (`ADMIN_SISTEMA_COTACOES`); a tela continua sendo `PortalCotacoesConfig`.
 */
